import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux';
import { Container } from 'react-bootstrap';

import socket from '../Components/Main/socket';

import MainHeader from '../Components/Main/MainHeader.jsx';
import ConnectedUsers from '../Components/Main/ConnectedUsers.jsx';
import Chat from '../Components/Main/Chat.jsx';
import Settings from './Settings';

// import CustomToast from '../Components/Main/CustomToast.jsx';

const MainWindow = () =>{
    const [ connectedUsers, setConnectedUsers ] = useState([]);
    const [ privateChatUser, setPrivateChatUser] = useState('');
    
    const location = useLocation();

    const { name, publicId, avatar, status } =  useSelector(state => state.user);

    const refreshConnectedUsersList = () =>{
        socket.emit('getConnectedUsers')
        socket.emit('newUser', {user: {name, publicId, avatar, status}})
    }
       
    useEffect(()=>{
        socket.on('connect', ()=>{
            socket.emit('newUser', {user: {name, publicId, avatar, status}})
        });
        
        socket.on('connectedUsers', (data)=>{
            let list = data.filter(u=>u.publicId !== publicId )
            setConnectedUsers(list);
        });
        
        socket.connect();

        return ()=>socket.disconnect();
    },[name, publicId, avatar, status])
 
    return(
        <Container fluid className='m-0 p-0 d-flex column vh-100 align-items-center justify-content-center justify-lg-content-end'>            
            <div className='shadow-lg chatContainer'>
                <MainHeader users={connectedUsers} socket={socket}/>
                    <div className='d-flex' style={{height: 'calc(100% - 50px)'}} >
                        {
                            location.pathname === '/main' ?
                            <>
                                <ConnectedUsers 
                                    data ={connectedUsers} 
                                    privateChatUser={privateChatUser} 
                                    setParticipant={setPrivateChatUser}
                                    refreshConnectedUsersList = {refreshConnectedUsersList}
                                />
                                <Chat 
                                    socket={socket} 
                                    privateChatUser={privateChatUser}
                                /> 
                            </> 
                            :
                            location.pathname === '/main/settings' && <Settings/>
                        }
                        {/* <CustomToast className='fixed-bottom' style={{bottom: 100, right: 3}} data={toastData} reset={()=>setToastData} /> */}
                    </div>
            </div>
        </Container>
    )
}

export default MainWindow;